import React from "react";
import { BaseForm, Input, Textarea } from "../../../../components/Form";
import Tabs from "../../../../components/Tabs";
import Dialog from "../../../../components/Popup/Dialog";
import API from "../../../../lib/api";
import { isExtensionEnabled } from "../../../../lib/auth";
import { getMessage } from "../../../../lib/translator";
import { get } from "../../../../lib/storage";
import { withRouter } from "react-router-dom";

import "./style.css";

class SEOSetting extends BaseForm {
  constructor(props) {
    super(props);
    this.state = {
      page: 0,
      submitting: false,
      showSuccessDialog: false,
    };

    this.pages = ["HOME", "PRODUCT", "CATEGORY"];

    if (isExtensionEnabled("ProductTagSupport")) {
      this.pages.push("TAG");
    }

    if (isExtensionEnabled("MultiBrandSupport")) {
      this.pages.push("BRAND");
    }

    this.changePage = this.changePage.bind(this);
    this.closeDialog = this.closeDialog.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    this.fetchSeo();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.location &&
      prevProps.location.key !== this.props.location.key
    ) {
      this.fetchSeo();
    }
  }

  fetchSeo() {
    this.api = new API({ url: "/account-service/seo" });
    this.api
      .get()
      .then(
        (response) => {
          let transformedResponse = response.data.seo;
          this.seos = response.data.seo;
          let values = {};
          transformedResponse.forEach((seo) => {
            let page = seo.page.name;
            values[page] = {
              description: seo.description,
              title: seo.title,
              keywords: seo.keywords,
            };
          });
          this.setState({
            values: values,
          });
        },
        (error) => console.error(error)
      )
      .catch((error) => {
        console.error(error);
      });
  }
  componentWillUnmount() {
    this.api && this.api.cancel();
  }

  changePage(page) {
    this.setState(
      {
        page: page,
      },
      this.fetchPageData
    );
  }

  closeDialog() {
    this.setState({
      showSuccessDialog: false,
    });
  }

  handleSubmit(data) {
    const pageName = this.pages[this.state.page];
    let seo = this.seos.find((seo) => seo.page.name === pageName) || {};
    const id = seo.id;
    let thisSeo = data[pageName] || {};

    let savePromise;
    if (id) {
      savePromise = this.updateSeo(id, seo, thisSeo);
    } else if (thisSeo.title || thisSeo.description || thisSeo.keywords) {
      savePromise = this.createSeo(pageName, thisSeo);
    } else {
      return Promise.resolve();
    }

    return savePromise
      .then(
        () => {
          this.setState({
            formError: "",
            showSuccessDialog: true,
          });
          this.fetchSeo();
        },
        (error) => {
          this.setState({
            formError: error.message,
          });
        },
      )
      .catch((error) => {
        console.error(error);
      });
  }

  updateSeo(id, seo, thisSeo) {
    const api = new API({ url: `/account-service/seo/${id}` });

    const params = {
      ...seo,
      title: thisSeo.title,
      description: thisSeo.description,
      keywords: thisSeo.keywords,
    };
    return api.put(params);
  }

  createSeo(pageName, thisSeo) {
    const baseApi = new API({ url: "/account-service/seo" });
    return baseApi.get({}, { "Accept-Language": "en" }).then((response) => {
      const baseSeos = (response.data && response.data.seo) || [];
      const baseSeo = baseSeos.find((s) => s.page && s.page.name === pageName);
      const pageId =
        baseSeo && baseSeo.page != null ? `${baseSeo.page.id}` : undefined;
      const params = {
        url: null,
        pageId: pageId,
        language: get("dataLang") || "en",
        title: thisSeo.title,
        description: thisSeo.description,
        keywords: thisSeo.keywords,
      };
      const api = new API({ url: "/account-service/seo" });
      return api.post(params);
    });
  }

  onSubmit(data) {
    this.setState({
      submitting: true,
    });
    this.handleSubmit(data)
      .then(() => {
        this.setState({
          submitting: false,
        });
      })
      .catch((error) => {
        console.error(error);
      });
  }

  render() {
    const { Form } = this.components;
    const { SubmitButton } = this.buttons;
    const page = this.pages[this.state.page];
    const name = page.split(" ")[0];

    return (
      <div className="seo-form">
        <Dialog
          show={this.state.showSuccessDialog}
          className="success"
          title={getMessage("extensions.seo.success")}
          information={getMessage("extensions.seo.save.successful")}
          close={this.closeDialog}
          closeText={getMessage("extensions.seo.ok")}
        />
        <Form>
          {this.state.formError && (
            <div className="form-error">{this.state.formError}</div>
          )}
          <div className="tab-container">
            <Tabs
              items={this.pages.map((page) => `${page}`)}
              default={this.state.page}
              onClick={(index) => this.changePage(index)}
            />
            <div className="tab-details">
              <div className={`${name}-page`}>
                <Input
                  label={getMessage("extensions.seo.title")}
                  name="title"
                  dir={get("dataLang") === "ar" ? "rtl" : "ltr"}
                  {...this.generateStateMappers({
                    stateKeys: [name, "title"],
                    loseEmphasisOnFill: true,
                  })}
                  maxLength={150}
                >
                  {getMessage("extensions.seo.title.explanation")}
                  <a
                    href="https://support.google.com/webmasters/answer/7451184?hl=en"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {" "}
                    {getMessage("extensions.seo.read.more")}
                  </a>
                </Input>
                <Textarea
                  label={getMessage("extensions.seo.description")}
                  name="description"
                  dir={get("dataLang") === "ar" ? "rtl" : "ltr"}
                  {...this.generateStateMappers({
                    stateKeys: [name, "description"],
                    loseEmphasisOnFill: true,
                  })}
                  maxLength={64000}
                >
                  {" "}
                  {getMessage("extensions.seo.description.explanation")}
                  <a
                    href="https://support.google.com/webmasters/answer/7451184?hl=en"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {" "}
                    {getMessage("extensions.seo.read.more")}
                  </a>
                </Textarea>
                <Textarea
                  label={getMessage("extensions.seo.keywords")}
                  name="keywords"
                  dir={get("dataLang") === "ar" ? "rtl" : "ltr"}
                  {...this.generateStateMappers({
                    stateKeys: [name, "keywords"],
                    loseEmphasisOnFill: true,
                  })}
                  maxLength={64000}
                >
                  {getMessage("extensions.seo.keywords.explanation")}
                  <a
                    href="https://support.google.com/webmasters/answer/7451184?hl=en"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {" "}
                    {getMessage("extensions.seo.read.more")}
                  </a>
                </Textarea>
              </div>
              <SubmitButton>{getMessage("extensions.seo.save")}</SubmitButton>
              <button
                type="button"
                className="button"
                onClick={() => this.props.history.goBack()}
              >
                {getMessage("extensions.seo.cancel")}
              </button>
            </div>
          </div>
        </Form>
      </div>
    );
  }
}

export default withRouter(SEOSetting);
